<template>
  <div class="pay-box" v-if="loading">
    <div class="top-box">
      <span class="hint-title">订单提交成功！</span>
      <span class="hint-time">请在 <i>{{ timeStr }}</i> 内完成支付</span>
      <span class="hint-text">超时后订单自动关闭！</span>
      <div class="order-info">
        <div>
          <span class="oi-wait-pay-ttl">应付金额：<i>{{ $fn.initPrice(info.waitPayTtl, 0) }}</i><i>{{
            $fn.initPrice(info.waitPayTtl, 1) }}元</i></span>
          <span class="oi-order-no">订单号：<i>{{ info.orderNo }}</i></span>
          <i class="oi-line"></i>
          <img class="pay-img" :src="`data:image/png;base64,${info.base64}`" />
          <span class="pay-hint">“请保存二维码图片，打开{{$route.query.payMode == 0 ? '微信': '支付宝'}}扫码支付”</span>
          <img class="pay-type" v-if="$route.query.payMode == 0" src="https://xhdata.wan4.com/wsw-h5-wx-pay.png" />
          <img class="pay-type" v-else src="https://xhdata.wan4.com/wsw-h5-pay-ali.png" />
        </div>
      </div>
    </div>
  </div>
  <!-- 空页面加载 -->
  <van-loading v-else type="spinner" color="#111111" />
</template>

<script>
export default {
  name: 'Pay',
  data() {
    return {
      info: {},
      timeStr: '00:00',
      loading: false,
      interval: '',
    }
  },
  created() {
    this.getData();
  },
  beforeDestroy(){
    if(this.interval){
      clearInterval(this.interval)
    }
  },
  components: {

  },
  methods: {
    getData() {
      this.$ajax('/iap-api/wan4/order/orderPayment.do', { paymentSn: this.$route.query.paymentSn, payMode: this.$route.query.payMode }).then(res => {
        this.info = res.data;
        this.loading = true;
        this.getTime(this.info.expireTick - new Date().getTime())
        this.interval = setInterval(() => {
          this.getTime(this.info.expireTick - new Date().getTime())
          this.getState();
        }, 1000);
      })
    },
    //倒计时
    getTime: function (time) {
      if (time < 0) {
        this.timeStr = '00:00'
        return
      }
      let ts = time / 1000
      let f = parseInt(ts / 60)
      f < 0 ? f = 0 : ''
      let s = parseInt(ts % 60)
      s < 10 ? s = '0' + s : ''
      this.timeStr = f + ':' + s
    },
    getState() {
      this.$ajax('/iap-api/wan4/order/orderPaymentQuery.do', { paymentSn: this.$route.query.paymentSn }).then(res => {
        if (res.data == 2 || res.data == 0) {
          this.$router.replace(`/order/payResult?state=${res.data}&paymentSn=${this.$route.query.paymentSn}`)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.pay-box {
  display: flex;
  flex-direction: column;

  .top-box {
    background: linear-gradient(251deg, #FF9B7A 0%, #FF6634 62.61%);
    display: flex;
    flex-direction: column;
    min-height: 308px;
    padding: 40px 32px 0;
    margin-bottom: 881px;

    .hint-title {
      color: #FFF;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px;
    }

    .hint-time {
      color: #FFF;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      margin-top: 8px;

      >i {
        color: #FFF;
        font-size: 42px;
        font-style: normal;
        font-weight: 600;
        line-height: 58px;
      }
    }

    .hint-text {
      color: #FFF;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      margin-top: 8px;
    }

    .order-info {
      border-radius: 25px;
      border: 1px solid #FF9D7D;
      background: #E63900;
      height: 18px;
      margin-top: 36px;
      position: relative;

      >div {
        position: absolute;
        top: 50%;
        height: 881px;
        left: 12px;
        right: 12px;
        border-radius: 0px 0px 4px 4px;
        background: linear-gradient(180deg, #FFBFAA -1.7%, #FFF 3.06%);
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
        display: flex;
        flex-direction: column;
        padding: 32px;

        .oi-wait-pay-ttl {
          color: #333;
          font-size: 28px;
          font-style: normal;
          font-weight: 600;
          line-height: 36px;

          >i {
            color: #F53F3F;
            font-size: 38px;
            font-style: normal;
            font-weight: 600;
            line-height: 54px;
          }

          >i+i {
            color: #F53F3F;
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 36px;
          }
        }

        .oi-order-no {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
          margin-top: 18px;

          >i {
            color: #333;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: 34px;
          }
        }

        .oi-line {
          margin: 32px 0 0;
          position: relative;
          height: 1px;
          overflow: hidden;

          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            border: 5px dashed #ccc;
          }
        }

        .pay-img {
          height: 440px;
          width: 440px;
          margin: 80px auto 0;
          padding: 20px;
          box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.18);
        }

        .pay-hint {
          color: #999;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 34px;
          margin: 24px auto 0;
        }

        .pay-type {
          margin: 38px auto 0;
          height: 38px;
        }
      }
    }
  }
}
</style>
